/**
 * PerformAI API
 * PerformAI API documentation
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EventDTO } from './eventDTO';


export interface AthleteDTO {
    awards?: Array<string>;
    birthYear?: number;
    endYear?: number;
    events?: Array<EventDTO>;
    id?: string;
    images?: Array<string>;
    name: string;
    nationality?: string;
    primaryImage?: string;
    startYear?: number;
    teams?: Array<string>;
}

